// AWS Amplify Configuration for v6 - simplified for basic setup
const awsConfig = {
  Auth: {
    Cognito: {
      region: 'us-west-2',
      userPoolId: 'us-west-2_placeholder',
      userPoolClientId: 'placeholder'
    }
  }
};

export default awsConfig;
